module.exports = __webpack_public_path__ + "static/media/riskreporter.43a467c6.PNG";